export const Clients = [
  {
    title: "Minister Of Military Production",
    img: "images/Minister-Of-Military-Production.webp",
  },
  {
    title: "Egyptian Armed Forces Engineering Authority",
    img: "images/Egyptian-Armed-Forces-Engineering-Authority.webp",
  },
  {
    title: "New Urban Authority",
    img: "images/New-Urban-Authority.webp",
  },
  {
    title: "Wadi El Nile For Contracting & Real Estate Investments",
    img: "images/wadi-el-nile-for-contracting-real-estate-investments.webp",
  },
  {
    title: "General Organization For Physical Planning",
    img: "images/General-Organization-For-Physical-Planning.webp",
  },
  {
    title: "Nasr General Contracting Co. European Shola School",
    img: "images/Nasr-General-Contracting-Co-European-Shola-School.webp",
  },
  {
    title: "The Arab Contractors",
    img: "images/The-Arab-Contractors.webp",
  },
  {
    title: "Misr Consult",
    img: "images/Misr-Consult.webp",
  },
  {
    title: "Home Insurance Agency In Cairo",
    img: "images/Home-Insurance-Agency-In-Cairo.webp",
  },
  {
    title: "Engineering facilities of Zagazig University",
    img: "images/Engineering-facilities-of-Zagazig-University.webp",
  },
  {
    title: "Misr Concrete Development Co",
    img: "images/Misr-Concrete-Development-Co.webp",
  },
  {
    title: "Sherkaet Matahen & Makhabez Ganoub Al Kahera & El Giza",
    img: "images/sherkaet-matahen-makhabez-ganoub-al-kahera-el-giza.webp",
  },
  {
    title: "Canal For General Contracting And Supplies",
    img: "images/Canal-For-General-Contracting-And-Supplies.webp",
  },
  {
    title: "General Authority For Health Insurance",
    img: "images/General-Authority-For-Health-Insurance.webp",
  },
  {
    title: "Investors Association",
    img: "images/Investors-Association.webp",
  },
  {
    title: "10th Of Ramadan Investor Association",
    img: "images/10th_Of_Ramadan_Investor_Association.webp",
  },
  {
    title: "Ministry Of Agriculture And Land Reclamation",
    img: "images/Ministry-Of-Agriculture-And-Land-Reclamation.webp",
  },
  {
    title: "General Nile Company For Desert Roads",
    img: "images/General-Nile-Company-For-Desert-Roads.webp",
  },
  {
    title: "Al-Qahera For Contacting And General Supplies",
    img: "images/Al-Qahera-For-Contacting-And-General-Supplies.webp",
  },
  {
    title: "Giza General Contracting",
    img: "images/Giza-General-Contracting.webp",
  },
];
